import { render, staticRenderFns } from "./groupStatistics.vue?vue&type=template&id=7bd92d56&"
import script from "./groupStatistics.vue?vue&type=script&lang=js&"
export * from "./groupStatistics.vue?vue&type=script&lang=js&"
import style0 from "./groupStatistics.vue?vue&type=style&index=0&id=7bd92d56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports